export const inputLaraThemeConfig = {
  colorScheme: {
    light: {
      disabledBackground: "{gray-50}",
      disabledColor: "{gray-500}",
      focus: {
        ringShadow: "none",
        ringOutline: "0",
        borderColor: "{primary-500}",
      },
      borderRadius: "var(--radius-8)",
      borderColor: "{gray-300}",
      shadow: "var(--shadow-xs)",
    },
  },
};
